var e = React.createElement;

export default class AppendSource extends React.Component {
    constructor(props) {
        super(props);
        this.dataI18nKeys = ["source-append-source"];
        this.setSelectedObject = this.setSelectedObject.bind(this);
        this.performPushReplaceState = this.performPushReplaceState.bind(this);
    }
    
    componentDidMount(){
        for(var key in this.dataI18nKeys){
            globalFunctions.applyTranslatedMessage(this.dataI18nKeys[key],
                                "[data-i18n=" + this.dataI18nKeys[key] + "]");
        }
    }

    setSelectedObject(e, type) {
        e.stopPropagation();
        this.performPushReplaceState();
        this.props.setSelectedObject({
            viewId: this.props.lastSourceViewId,
            id: this.props.refId,
            type: type
        });
    }

    performPushReplaceState() {
        var objID = this.props.lastSourceViewId;
        var objectID = objID.split('-');
        var mainObjUrl = {'objUrl' : objectID[0]};
        var lastSegment = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        if(objectID[0] != lastSegment) {
          window.history.replaceState(window.location.href,'ObjURL',objID);
        } else {
          window.history.pushState(mainObjUrl,'Main',objID);
        }
      }

    handleClick(e,refId) {

        var tooltiptext = document.querySelector('#tooltiptext-'+refId);
        // console.log(tooltiptext);
        var tooltipclass = document.querySelector('.tooltiptext');

        if(document.getElementById(refId  + "-addbtntext").classList.contains('add-toggle-button')) {
            $(".tooltiptext").map(function() {
                this.classList.add('hidden');
                this.classList.remove('visible');
                tooltiptext.classList.remove('visible');
                tooltiptext.classList.add('hidden');
            }).get();
            $(".add-button").removeClass("add-toggle-button").addClass("remove-toggle-button");
            $("#"+refId  + "-addbtntext").removeClass("add-toggle-button").addClass("remove-toggle-button");
        } else {
            $(".tooltiptext").map(function() {
                this.classList.add('hidden');
                this.classList.remove('visible');
                tooltiptext.classList.remove('hidden');
                tooltiptext.classList.add('visible');
            }).get();

            $(".add-button").removeClass("add-toggle-button").addClass("remove-toggle-button");
            $("#"+refId  + "-addbtntext").removeClass("remove-toggle-button").addClass("add-toggle-button");
        }

        //  $(".tooltiptext").map(function() {
        //     this.classList.add('hidden');
        //     this.classList.remove('visible');
        //     tooltiptext.classList.remove('hidden');
        //     tooltiptext.classList.add('visible');
        // }).get();
        

        e.stopPropagation(); 
        e.preventDefault();
    }

    render() {
        return(      
            <div className="two wide column" 
                style={this.props.appendStatus == globalFunctions.objectTypes.OPEN_POINT ?
                        {marginRight: '0px',zIndex:1, display: this.props.isLoggedIn ? 'block' : this.props.appendStatus == globalFunctions.objectTypes.OPEN_POINT ? 'block' : 'none'}
                        :
                        
                            this.props.appendStatus == globalFunctions.objectTypes.END_POINT ? 
                                {marginRight: '0px',zIndex:1}
                                :
                                {marginRight: '0px',zIndex:1}
                            
                        

                } 
            >
                {this.props.appendStatus == globalFunctions.objectTypes.OPEN_POINT && (
                    <div onClick={(e) => this.setSelectedObject(e,globalFunctions.objectTypes.OPEN_POINT)}>
                        <img src={site_url + "/img/image-open-icon-new.png"} class="openImage"/><span className="open-text">Source to this may exist</span>
                        {this.props.selectedObjectType === globalFunctions.objectTypes.OPEN_POINT ? <hr style={{top: 135,width: 180}} className="selected-source" /> : null}
                    </div>
                )} 
                {this.props.appendStatus == globalFunctions.objectTypes.END_POINT && (
                    <div onClick={(e) => this.setSelectedObject(e,globalFunctions.objectTypes.END_POINT)} className="point-icon">
                        <img style={{height: 45}} src={site_url + "/img/image-end-point.png"} /><span className="open-text" style={{marginLeft: 5, width: 200, top: 15}}>Last source (main source)</span>
                        {this.props.selectedObjectType === globalFunctions.objectTypes.END_POINT ? <hr style={{width: 170}} className="selected-source" /> : null}
                    </div>
                )}
                {this.props.isOwner && this.props.appendStatus =='SourcePoint' && (
                    <div className="secondary-btn-block tooltipAppendSource">
                        <button className="ui labeled icon button secondary-btn basic add-button remove-toggle-button" id={this.props.refId  + "-addbtntext"} onClick={(e) =>{this.handleClick(e,this.props.refId);}}>
                                    <i className="indent icon"></i>
                                    <span data-i18n={this.dataI18nKeys[0]} style={{marginLeft: -15}}>Add ...</span>
                        </button>
                        <div className="tooltiptext hidden" id={"tooltiptext-" + this.props.refId}>
                            <div className="add-source" onClick={(e) => {
                                this.props.addSource(this.props.parentId, this.props.newSourceViewId);
                                e.preventDefault();
                                e.stopPropagation();
                            }}><img src={site_url + "/img/source-point.png"} /><span style={{marginLeft: 5}}>source (to source <b>{this.props.lastSourceIndex}</b>)</span></div>
                            <hr style={{border: 0,borderTop: '1px solid lightgray'}}/>
                            <div style={{marginTop: 8}} onClick={(e) => this.props.appendSource(this.props.refId, 2)}><img src={site_url + "/img/end-point.png"} /><span>Endpoint</span></div>
                            <div onClick={(e) => this.props.appendSource(this.props.refId, 1)}><img src={site_url + "/img/open-point.png"} /><span>Openpoint</span></div>
                                                       
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/AppendSource.js